import React from 'react';

// lib 
import Lottie from 'lottie-react';

// components
import QuestionHeader from '../../PensionInsuranceWizardBlock/Components/Wizard/QuestionHeader'

// utils
import * as constants from '../Utils/constants';

import iconAnimData from '../../../AnimationFiles/hearts.json'

const onRedirect = () => {
    window.location.href = `${constants.redirects.start}`
}

const Success = () => {
    return (
        <div className="signature-process">
            <div className="signature-process__container">

                    <div className="pension-wizard-block__question pension-wizard-block__question__sign">
                        <div className="pension-wizard-block__question__card">
     
                            <Lottie
                                className="pension-wizard-block__question__sign__animation"
                                animationData={iconAnimData}
                                autoplay={true}
                            />
     
                            <QuestionHeader
                                showCount={false}
                                headline={constants.final.headline}
                                text={constants.final.text}
                                paragraph2={constants.final.paragraph2}
                            />
                            <button
                                onClick={onRedirect}
                                type="button"
                                className="button button--green">
                                {constants.final.buttonText}
                            </button>
                        </div>
                    </div> 
                </div>
            </div>

      )
}

export default Success

